module.exports = __webpack_public_path__ + "static/media/video-thumbnail-tablet-es.315a06b3.png";